/** Phân quyền — nhóm khách hàng */
export const NHOM_KHACH_HANG_PERMISSION_CODES = {
  WEB_BH_NHOM_KHACH_HANG_LIST: 'WEB_BH_NHOM_KHACH_HANG_LIST',
  WEB_BH_NHOM_KHACH_HANG_ADD: 'WEB_BH_NHOM_KHACH_HANG_ADD',
  WEB_BH_NHOM_KHACH_HANG_EDIT: 'WEB_BH_NHOM_KHACH_HANG_EDIT',
  WEB_BH_NHOM_KHACH_HANG_DELETE: 'WEB_BH_NHOM_KHACH_HANG_DELETE',
  WEB_BH_NHOM_KHACH_HANG_IMPORT: 'WEB_BH_NHOM_KHACH_HANG_IMPORT',
  WEB_BH_NHOM_KHACH_HANG_EXPORT: 'WEB_BH_NHOM_KHACH_HANG_EXPORT',
} as const

export type NhomKhachHangPermissionCode =
  (typeof NHOM_KHACH_HANG_PERMISSION_CODES)[keyof typeof NHOM_KHACH_HANG_PERMISSION_CODES]

export const NHOM_KHACH_HANG_MUTATE_PERMISSIONS = [
  NHOM_KHACH_HANG_PERMISSION_CODES.WEB_BH_NHOM_KHACH_HANG_ADD,
  NHOM_KHACH_HANG_PERMISSION_CODES.WEB_BH_NHOM_KHACH_HANG_EDIT,
  NHOM_KHACH_HANG_PERMISSION_CODES.WEB_BH_NHOM_KHACH_HANG_DELETE,
  NHOM_KHACH_HANG_PERMISSION_CODES.WEB_BH_NHOM_KHACH_HANG_IMPORT,
] as const
